export default "__VITE_ASSET__N6GArvnB__"